import { ADD_INBOX, APPEND_INBOX } from '../actionsList';

const initialSettings = {
    list: [],
    count: 0
};

const inboxReducer = (state = initialSettings, action) => {
    switch (action.type) {
        case ADD_INBOX:
            {
                // console.log('action.options', action.options)
                let list = action.options.list
                let count = action.options.count
                return {
                    ...state,
                    list: list,
                    count: count,
                }
            }
        case APPEND_INBOX: {
            // console.log('APPEND_INBOX')
            let list = [...state.list]
            let count = state.count
            action.options.map((item) => {
                let found
                let cIndex
                list.map((element, index) => {
                    if (element._id == item._id) {
                        found = true
                        cIndex = index
                    }
                })
                // console.log('foundisiss',found)
                if (!found) {
                    count = count + 1
                    list.push(item)
                } else {
                    list[cIndex] = item
                }
            })
            return {
                ...state,
                list: list,
                count: count,
            }
        }
        default:
            return state;
    }
}

export default inboxReducer;